import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SliceTypes } from 'utils';
import { RootState } from './rootReducer';

const initialState = {
    type: '',
    header: '',
    message: '',
    duration: 3000,
};

export const serviceSlice = createSlice({
    name: SliceTypes.SERVICE,
    initialState,
    reducers: {
        updateNotification: (
            state,
            { payload: { type, header, message, duration } }: PayloadAction<any>,
        ) => {
            state.type = type;
            state.header = header;
            state.message = message;
            state.duration = duration;
        },
        resetNotification: (state) => {
            state.type = '';
            state.header = '';
            state.message = '';
            state.duration = 5000;
        },
    },
});

export const { updateNotification, resetNotification } = serviceSlice.actions;

export const serviceDataSlice = (state: RootState) => state.service;

export default serviceSlice.reducer;
